import React, { useState } from 'react'
import { apiGet } from '../../../generic/Api_Functions'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { DefaultAccordion } from '../../../generic/DefaultAccordion'
import { Stack, Typography } from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction'
import SmartMateriaUITable from '../../../generic/SmartMateriaUITable'
import NoOk from '../../../../images/NO_OK.png'
import Ok from '../../../../images/OK.png'

/**
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/FabricationOrder").FabricationOrder} FabricationOrder Fabrication Order object
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/LinkedJobReference").LinkedJobReference} LinkedJobReference Linked Job Reference object
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/TaskReference").TaskReference} TaskReference Task Reference object
*/

/**
 * @param {Object} props
 * @param {FabricationOrder} props.fabricationOrder
 * @param {LinkedJobReference} props.linkedJobReference
 * @param {TaskReference} props.taskReference
 * @returns
 */
const TaskReference = ({ fabricationOrder, linkedJobReference, taskReference }) => {
  const { t_ } = useSmartTranslation()
  const [expandedAccordionMilling, setExpandedAccordionMilling] = useState(false)
  const [expandedAccordionTurning, setExpandedAccordionTurning] = useState(false)

  const getTaskReferenceHeader = () => {
    return (
      <>
        <Stack direction='row' gap={10}>
          <Typography sx={{ minWidth: '15rem' }}>{t_('Task') + ': ' + taskReference.name}</Typography>
          <Stack direction='row'>
            <Typography>{t_('Duration') + ': ' + taskReference.duration}</Typography>
          </Stack>
        </Stack>
        <Stack>
          <ConstructionIcon color={taskReference.toolsOk ? 'primary' : 'error'} />
        </Stack>
      </>
    )
  }

  const getCommonColumns = () => [
    {
      name: t_('Tool Name'),
      field: 'toolName'
    },
    {
      name: t_('Tool Number'),
      field: 'toolNumber'
    },
    {
      name: t_('Consumption'),
      field: 'consumption'
    }
  ]

  const millingColumns = [
    ...getCommonColumns(),
    {
      name: t_('D'),
      field: 'D'
    },
    {
      name: t_('L'),
      field: 'L'
    }
  ]

  const turningColumns = [
    ...getCommonColumns(),
    {
      name: t_('XL'),
      field: 'XL'
    },
    {
      name: t_('YL'),
      field: 'YL'
    },
    {
      name: t_('ZL'),
      field: 'ZL'
    }
  ]

  const imgStyle = {
    verticalAlign: 'middle',
    height: '1.8rem',
    width: '1.8rem'
  }

  const createColumns = () => {
    const response = linkedJobReference?.deviceList?.map((device) => {
      return {
        name: device.name,
        field: 'devices',
        readOnly: true,
        render: (row) => {
          return (
            <img
              style={imgStyle}
              src={row.deviceList.find((item) => item.id === device.id)?.toolOk ? Ok : NoOk}
              alt=''
            />
          )
        }
      }
    })
    return response
  }

  const getEndPoint = 'toolTable/fabricationOrder/' + fabricationOrder.id + '/linkedJobReference/' + linkedJobReference.id + '/taskReference/' + taskReference.id + '/'

  const dataFetchMilling = () => {
    if (!expandedAccordionMilling) {
      return []
    }
    return apiGet(getEndPoint + 'Milling')
  }

  const dataFetchTurning = () => {
    if (!expandedAccordionMilling) {
      return []
    }
    return apiGet(getEndPoint + 'Turning')
  }

  const getCollumns = (type) => {
    const columns = type === 'Milling' ? millingColumns : turningColumns
    return columns.concat(createColumns()).map(item => ({ ...item }))
  }

  return (
    <DefaultAccordion
      key={taskReference.id}
      headerRender={getTaskReferenceHeader()}
      defaultExpanded={false}
      headerSx={{ backgroundColor: theme => theme.palette.background.paper }}
      contentSx={{ backgroundColor: theme => theme.palette.background.paper }}
    >
      <DefaultAccordion
        key={taskReference.id + t_('Milling')}
        onExpandedStatusChange={(expanded) => {
          if (expanded !== expandedAccordionMilling) {
            setExpandedAccordionMilling(expanded)
          }
        }}
        title={t_('Milling')}
        defaultExpanded={false}
        headerSx={{ backgroundColor: theme => theme.palette.background.paper }}
        contentSx={{ backgroundColor: theme => theme.palette.background.paper }}
      >
        <SmartMateriaUITable
          columns={getCollumns('Milling')}
          dataFetch={dataFetchMilling}
        />
      </DefaultAccordion>
      <DefaultAccordion
        key={taskReference.id + t_('Turning')}
        onExpandedStatusChange={(expanded) => {
          if (expanded !== expandedAccordionTurning) {
            setExpandedAccordionTurning(expanded)
          }
        }}
        title={t_('Turning')}
        defaultExpanded={false}
        headerSx={{ backgroundColor: theme => theme.palette.background.paper }}
        contentSx={{ backgroundColor: theme => theme.palette.background.paper }}
      >
        <SmartMateriaUITable
          columns={getCollumns('Turning')}
          dataFetch={dataFetchTurning}
        />
      </DefaultAccordion>

    </DefaultAccordion>
  )
}

export default TaskReference
